module.exports = "<div id=\"snackbar\">{{message}}</div>"